export default __webpack_public_path__ + "locales/lv/ConnectDialog.json?hash=7e70a2c4fdeb7c739f22e8769cee4254";